<script>
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrSelect',
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => ([])
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    validateCallback: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    /**
     * 数据改变方法
     */
    handleChange({ value }) {
      // 校验成功
      this.$emit('change', value)
      this.$emit('input', value)
      // 关闭弹框
      this.visible = false
      // 等页面渲染完成后开始校验数据
      this.$nextTick(this.validate)
    },

    /**
     * 关闭弹出框方法
     */
    handleCancel() {
      // 开始校验数据
      this.validate()
      // 通知父组件关闭方法
      this.$emit('close')
      // 隐藏picker组件
      this.visible = false
    }
  },
  render() {
    // 取出当前选中的选项
    const option = this.options.find(option => option.value === this.value) || {}
    return (
      <div class='rnr-select'>
        <van-field
          value={option.name}
          clear-trigger='always'
          clickable
          is-link
          label={this.label}
          required={this.required}
          readonly
          placeholder={`请选择${this.label}`}
          input-align='right'
          {...(this.attrs || {})}
          onClick={() => (this.visible = true)}
        />
        <van-popup value={this.visible} onInput={visible => (this.visible = visible)} round position='bottom'>
          <van-picker
            columns={this.options}
            value-key='name'
            title={this.label}
            show-toolbar
            onConfirm={this.handleChange}
            onCancel={this.handleCancel}
          />
        </van-popup>
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormRender/select.vue